import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useMe } from "@/context/MeContext";
import { Avatar, PageHeader } from "@/components/common";
import { MediaPicker } from "@/components/PostMedia";
import { MentionInput, mentionIds } from "@/components/Mentions";
import { Button } from "@/components/ui/button";

export default function CreatePost() {
  const { me } = useMe();
  const nav = useNavigate();
  const [text, setText] = useState("");
  const [mentions, setMentions] = useState([]);
  const [images, setImages] = useState([]);
  const [video, setVideo] = useState(null);
  const [tags, setTags] = useState("");
  const [busy, setBusy] = useState(false);
  const kind = "fact";

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/posts", { text, images, video, kind, tags: tags.split(/[,\s]+/).filter(Boolean), mentions: mentionIds(text, mentions) });
      toast.success("Posted. Middle is checking it now");
      nav("/");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <div className="mx-auto max-w-2xl" data-testid="create-post-page">
      <PageHeader env="facts" title="Share a fact" subtitle="Middle is for facts only. Say what happened, with numbers, places and dates where you can." />
      <div className="surface space-y-5 p-5 sm:p-6">
        <div className="flex gap-3">
          <Avatar user={me} size={42} />
          <MentionInput multiline testid="post-text-input" value={text} onChange={setText} mentions={mentions} setMentions={setMentions} rows={5} placeholder="e.g. The Reserve Bank kept the cash rate at 3.85% on 4 November"
            className="w-full resize-none bg-transparent pt-2 text-base leading-relaxed outline-none placeholder:text-slate-400" />
        </div>
        <p className="rounded-xl bg-emerald-50 p-3 text-xs text-emerald-900" data-testid="post-fact-hint">Middle checks your fact against its approved sources and shows whether they corroborate it. Corroborated or disputed public Facts also appear in Facts. Opinions and personal updates can't be posted: if it isn't a checkable fact, only you will see it until you edit or delete it.</p>
        <MediaPicker images={images} setImages={setImages} video={video} setVideo={setVideo} />
        <input data-testid="post-tags-input" value={tags} onChange={(e) => setTags(e.target.value)} placeholder="Interests / tags, e.g. hiking, food"
          className="w-full rounded-xl border border-border px-4 py-2.5 text-sm outline-none focus:ring-2 focus:ring-slate-200" />
        <p className="text-xs text-slate-500" data-testid="post-public-note">Facts are public: anyone on Middle can see this, and people who follow you will see it in their feed.</p>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={() => nav(-1)}>Cancel</Button>
          <Button data-testid="post-submit-btn" disabled={busy || (!text.trim() && !images.length) || (kind === "fact" && text.trim().length < 20)} onClick={submit} className="rounded-full px-6">Post</Button>
        </div>
      </div>
    </div>
  );
}
